import React from 'react';
import { compose, pure } from 'recompose';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DetailTextButton from '../atoms/DetailTextButton';

const styles = {};

const enhance = compose(pure);

const ShopTableBody = enhance(
  ({
    manageNotices,
    emptyRows,
    page,
    rowsPerPage,
    detailOpenAction,
    order,
    orderBy
  }) => {
    const sortedResult = _.orderBy(manageNotices, orderBy, order);
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(notice => {
            const params = {
              message: notice.message
            };
            return (
              <TableRow key={notice.manageNoticeId}>
                <TableCell>
                  {notice.noticeDate}
                  &nbsp;&nbsp;
                  {notice.title}
                </TableCell>
                <TableCell>
                  <DetailTextButton
                    params={params}
                    onClickAction={detailOpenAction}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(ShopTableBody);
